import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

import { ReactComponent as PreviousArrow } from 'assets/images/digitalCard/arrow-left.svg';
import { ReactComponent as NextArrow } from 'assets/images/digitalCard/arrow-right.svg';

import DigitalCard from './DigitalCard';
import getCardStyles from './getCardStyles';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const renderDigitalCardList = (accounts = [], onBarcodeClick, activeAccountIndex) => {
    if (!accounts.length) {
        return;
    }

    return accounts.map((account, i) => {
        const cardStyles = getCardStyles(account.merchantNumber);
        return (
            <DigitalCard
                accountNumber={account.accountNumber}
                isActive={i === activeAccountIndex}
                key={i}
                merchantCardBackgroundColor={cardStyles.merchantCardBackgroundColor}
                merchantCardBackgroundImage={cardStyles.merchantCardBackgroundImage}
                merchantCardLogo={cardStyles.merchantCardLogo}
                merchantCardLogoRightPosition={cardStyles.merchantCardLogoRightPosition}
                merchantCardLogoTopPosition={cardStyles.merchantCardLogoTopPosition}
                merchantLogoWidthPercentage={cardStyles.merchantLogoWidthPercentage}
                merchantName={account.merchantName}
                merchantNumber={account.merchantNumber}
                onBarcodeClick={() => onBarcodeClick(i)}
                ownerName={account.ownerName}
                showDisclaimer={cardStyles.showDisclaimer}
                showFairstoneLogo={cardStyles.showFairstoneLogo}
            />
        );
    });
};

class DigitalCardCarousel extends Component {
    componentDidMount() {
        // remove tabindex from dots to easily use carousel with a keyboard
        const dots = document.querySelector('.slick-dots');
        if (!dots) {
            return;
        }
        dots.childNodes.forEach((dot) => {
            dot.childNodes[0].setAttribute('tabIndex', '-1');
            dot.childNodes[0].setAttribute('aria-hidden', true);
        });
    }

    next = () => this.slider.slickNext();
    previous = () => this.slider.slickPrev();

    render() {
        const { accounts, activeAccountIndex, onBarcodeClick, ...rest } = this.props;
        const settings = {
            arrows: false,
            centerMode: true,
            centerPadding: '50px',
            className: 'digital-card-carousel',
            dots: true,
            focusOnSelect: true,
            infinite: false,
            initialSlide: activeAccountIndex,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 500,
            ...rest,
        };

        const showNextArrow = activeAccountIndex !== accounts.length - 1;
        const showPreviousArrow = activeAccountIndex !== 0;
        return (
            <div className="digital-card-carousel-container">
                <button
                    aria-hidden={!showPreviousArrow}
                    aria-label={this.props.intl.formatMessage({
                        id: 'digital.carousel.previous.arrow',
                    })}
                    className={`previous-arrow ${showPreviousArrow ? '' : 'disabled'}`}
                    onClick={this.previous}
                    tabIndex={showPreviousArrow ? '0' : '-1'}
                >
                    <PreviousArrow aria-hidden />
                </button>
                <div className="digital-card-carousel-wrapper">
                    <div className="digital-card-carousel-content">
                        <Slider ref={(c) => (this.slider = c)} {...settings}>
                            {renderDigitalCardList(accounts, onBarcodeClick, activeAccountIndex)}
                        </Slider>
                    </div>
                </div>
                <button
                    aria-hidden={!showNextArrow}
                    aria-label={this.props.intl.formatMessage({
                        id: 'digital.carousel.next.arrow',
                    })}
                    className={`next-arrow ${showNextArrow ? '' : 'disabled'}`}
                    onClick={this.next}
                    tabIndex={showNextArrow ? '0' : '-1'}
                >
                    <NextArrow aria-hidden />
                </button>
            </div>
        );
    }
}

DigitalCardCarousel.propTypes = {
    accounts: PropTypes.array,
    activeAccountIndex: PropTypes.number,
    afterChange: PropTypes.func,
    onBarcodeClick: PropTypes.func,
};

export default injectIntl(DigitalCardCarousel);
